import * as yup from 'yup';
import errorsText from '../../../utils/errorsText';

const validation = {
  fieldNames: {
    name: 'name',
    last_name: 'last_name',
    code_melli: 'code_melli',
    email: 'email',
    password: 'password',
    shenasname_number: 'shenasname_number',
    confirm_password: 'confirm_password',
    agent_id: 'agent_id',
    phone: 'phone',
    status: 'status',
    permissions: 'permissions',
    province_id: 'province_id',
    client_type: 'client_type',
    image: 'image',
    shenasname_image: 'shenasname_image',
    can_login: 'can_login',
  },
  defaultValue:{
    name : "",
    last_name : "",
    code_melli : "",
    email : "",
    password : "",
    confirm_password : "",
    shenasname_number : "",
    agent_id : null,
    province_id : null,
    client_type : null,
    status : null,
    phone : "",
    can_login: false,
  },
  schema: (isEdit) => {
    const obj = {
      [validation.fieldNames.name]: yup.string(),
      [validation.fieldNames.last_name]: yup.string(),
      [validation.fieldNames.code_melli]: yup.string(),
      [validation.fieldNames.email]: yup.string().required(errorsText.blankError()),
      [validation.fieldNames.password]: yup.string().min(8, errorsText.min(8)).required(errorsText.blankError()),
      [validation.fieldNames.confirm_password]: yup
        .string()
        .oneOf([yup.ref(validation.fieldNames.password), null], errorsText.passwordNotMatch()),
      [validation.fieldNames.shenasname_number]: yup.string(),
      [validation.fieldNames.agent_id]: yup.mixed().required(errorsText.blankError()),
      [validation.fieldNames.province_id]: yup.mixed().nullable(),
      [validation.fieldNames.client_type]: yup.mixed().nullable(),
      [validation.fieldNames.phone]: yup.string(),
    };

    if (isEdit) {
      obj[validation.fieldNames.password] = yup.string().nullable();
    }

    return yup.object().shape(obj);
  },
};
// "Passwords must match"
export default validation;
